module.exports = {
  appId: process.env.REACT_APP_SSO_CLIENT_ID,
  scopes: [
    "User.Read"
  ],
  redirectUri: process.env.REACT_APP_APP_URL,
  ssoURL: process.env.REACT_APP_SSO_URL,
}
